var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"info",style:({'color': _vm.color})},[_c('v-icon',{attrs:{"size":"xLarge","hovering":false}},[_vm._v(_vm._s(_vm.icon))]),_c('p',{staticClass:"info-message",domProps:{"innerHTML":_vm._s(_vm.msg)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }